module.exports = __webpack_public_path__ + "img/magazine60.8ab4dbff.jpg";